module.exports = __webpack_public_path__ + "img/cg_cricket.5873f26.jpg";